module.exports = __webpack_public_path__ + "img/zh-hk.webp";